import React, { ReactNode } from 'react';
import { Switch } from '@headlessui/react';
import classNames from 'classnames';
import { SubscriptionPaymentIntervalTypes } from '..';

export type ToggleComponentLabelType = 'regular' | 'strong' | 'heading';

interface Props {
  checked: boolean;
  labelType?: ToggleComponentLabelType;
  onChange: (intervalType: SubscriptionPaymentIntervalTypes) => void;
  isNeue?: boolean;
}

export const BillingToggle = ({
  checked = true,
  isNeue = false,
  labelType = 'heading',
  onChange,
}: Props) => {
  const labelClass =
    labelType === 'heading'
      ? 'heading-bedrock-tertiary'
      : labelType === 'strong'
      ? 'text-bedrock-p-strong'
      : 'text-bedrock-p';

  const switchColorClasses = classNames({
    'bg-bedrock-black': checked && !isNeue,
    'bg-bedrock-gray-medium': !checked && !isNeue,
    'bg-neue-gray-2': !checked && isNeue,
    'bg-neue-green-primary': checked && isNeue,
  });

  return (
    <Switch.Group>
      <div
        className={classNames(
          'flex items-center justify-center space-x-4 transform duration-200 ease-in-out',
          {
            'py-1': isNeue,
          }
        )}
      >
        <Switch.Label className=' select-none cursor-pointer'>
          <div className='flex flex-col items-center gap-1'>
            <span className='text-sm'>Billed monthly</span>
          </div>
        </Switch.Label>
        <Switch
          checked={checked}
          onChange={(val) => onChange(val ? 'year' : 'month')}
          className={classNames(
            'relative inline-flex has-hover  w-8 h-4 items-center rounded-full focus:outline-none shrink-0 my-0.5',
            switchColorClasses,
          )}
        >
          <span className='sr-only'>Enable notifications</span>
          {checked && isNeue && (
            <span className='absolute left-[6px] top-[5px] text-white'>
              <svg width='8' height='7' viewBox='0 0 8 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M1 3.66667L2.5 5.33333L6.66667 1'
                  stroke='currentColor'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </span>
          )}
          <span
            className={classNames(
              'bg-white w-3 h-3 inline-block rounded-full transform duration-200 ease-in-out',
              checked ? 'translate-x-[18px]' : 'translate-x-[2px]'
            )}
          />
        </Switch>
        <Switch.Label className=' select-none cursor-pointer'>
          <div className='flex flex-col items-center gap-1'>
            <span className='text-sm'>Billed yearly</span>
          </div>
        </Switch.Label>
      </div>
    </Switch.Group>
  );
};
